import React from 'react';
import DashboardIcon from '@material-ui/icons/Dashboard';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import Asset from '@material-ui/icons/WebAsset';
import Image from '@material-ui/icons/Wallpaper';
import Font from '@material-ui/icons/FontDownload';
import Users from '@material-ui/icons/SupervisorAccount';
import Offers from '@material-ui/icons/LocalOffer';
import Reports from '@material-ui/icons/LibraryBooks';
import Settings from '@material-ui/icons/Settings';
import Make from '@material-ui/icons/PermDataSetting';
import Sticker from '@material-ui/icons/TagFaces';
import Wallet from '@material-ui/icons/AccountBalanceWallet';
import EventNoteIcon from '@material-ui/icons/EventNote';
import ReturnOrder from '@material-ui/icons/SubdirectoryArrowLeft';
import Cancel from '@material-ui/icons/Cancel';
import Notification from '@material-ui/icons/Notifications';
import themes from './themes';
import cookie from 'react-cookies';

export const configuredTheme = themes[0].theme;

export const configuredLayout = {
  currentLayout: 'classic',
  notificationsOpen: false
};

let groupId = null;

const iconStyle = {
  fontSize: 16
};

let filterArray;
const filterMenuItem = [
  // title: 'Dashboards',
  // icon: <HomeIcon style={iconStyle} />,
  // children: [
  {
    title: 'Dashboards',
    href: '/',
    icon: <DashboardIcon style={iconStyle} />
  },
  // {
  //   title: 'Product',
  //   href: '/dashboards/product/add',
  //   icon: <Asset style={iconStyle} />
  // },
  // {
  //   title: 'Product Type',
  //   href: '/dashboards/productType',
  //   icon: <Asset style={iconStyle} />
  // },
  {
    title: 'Shipping Cost and GST On/Off',
    href: '/dashboards/settings',
    icon: <Settings style={iconStyle} />
  },
  {
    title: 'Editor Assets',
    key: 'editorAssets',
    icon: <Make style={iconStyle} />,
    children: [{
      title: 'Case Types',
      href: '/dashboards/casetype',
      icon: <EventNoteIcon style={iconStyle} />
    }, {
      title: 'Make & Model',
      key: 'makeModel',
      icon: <Make style={iconStyle} />,
      children: [{
        title: 'Add Make & Model',
        href: '/dashboards/makeModel/add'
      }, {
        title: 'Make, Model List',
        href: '/dashboards/chooseMake'
      }]
    }, {
      title: 'Background Images',
      href: '/dashboards/bgimages',
      icon: <Image style={iconStyle} />
    }, {
      title: 'Fonts',
      href: '/dashboards/font',
      icon: <Font style={iconStyle} />
    }, {
      title: 'Stickers',
      href: '/dashboards/chooseSticker',
      icon: <Sticker style={iconStyle} />
    }, {
      title: 'Bulk upload',
      href: '/dashboards/bulkUpload',
      icon: <Image style={iconStyle} />
    }]
  },
  {
    title: 'Catalogs',
    href: '/dashboards/chooseCatalog',
    icon: <Reports style={iconStyle} />
  },
  {
    title: 'Offers',
    href: '/dashboards/offers',
    icon: <Offers style={iconStyle} />
  },
  {
    title: 'Orders',
    href: '/dashboards/order/paid',
    icon: <ShoppingCartIcon style={iconStyle} />
  },
  {
    title: 'Orders',
    href: '/dashboards/order/new',
    icon: <ShoppingCartIcon style={iconStyle} />
  },
  {
    title: 'WooCommerce Orders',
    href: '/dashboards/woocommerceorder/paid',
    icon: <ShoppingCartIcon style={iconStyle} />
  },
  // {
  //   title: 'External Order Status',
  //   href: '/dashboards/externalorder',
  //   icon: <ShoppingCartIcon style={iconStyle} />
  // },
  {
    title: 'Return Orders',
    href: '/dashboards/returnorder',
    icon: <ReturnOrder style={iconStyle} />
  },
  {
    title: 'Cancelled Orders',
    href: '/dashboards/cancelorder',
    icon: <Cancel style={iconStyle} />
  },
  {
    title: 'Returned Orders',
    href: '/dashboards/returnedorders',
    icon: <ReturnOrder style={iconStyle} />
  },
  {
    title: 'Users',
    href: '/dashboards/users',
    icon: <Users style={iconStyle} />
  },
  {
    title: 'Amount Collection Report',
    href: '/dashboards/amount-report',
    icon: <Reports style={iconStyle} />
  },
  {
    title: 'Wallet report',
    href: '/dashboards/wallet-report',
    icon: <Reports style={iconStyle} />
  },
  {
    title: 'Assets',
    href: '/dashboards/assets',
    icon: <Asset style={iconStyle} />
  },
  {
    title: 'New order',
    key: 'newOrder',
    href: '/dashboards/neworder/product-type',
    icon: <EventNoteIcon style={iconStyle} />
  },
  {
    title: 'Wallet',
    href: '/dashboards/wallet',
    icon: <Wallet style={iconStyle} />
  },
  // ]
  // {
  //   title: 'Theming',
  //   href: '/theming',
  //   icon: <BuildIcon style={iconStyle} />
  // },
  // {
  // title: 'Apps',
  // icon: <DesktopWindowsIcon style={iconStyle} />,
  // children: [
  // {
  //   title: 'Email',
  //   href: '/apps/email',
  //   icon: <EmailIcon style={iconStyle} />
  // },
  // {
  //   title: 'Order Detail',
  //   href: '/apps/orderDetail',
  //   icon: <CheckCircleIcon style={iconStyle} />
  // },
  {
    title: 'Reports',
    key: 'reports',
    icon: <Reports style={iconStyle} />,
    children: [{
      title: 'Sale reports',
      href: '/dashboards/report/byOrder'
    }, {
      title: 'Dealer reports',
      href: '/dashboards/report/byDealer'
    }]
  },
  {
    title: 'Feedback',
    key: 'feedback',
    href: '/dashboards/feedback',
    icon: <EventNoteIcon style={iconStyle} />
  },
  {
    title: 'Notifications',
    key: 'notifications',
    href: '/dashboards/notifications',
    icon: <Notification style={iconStyle} />
  },
  {
    title: 'Broadcast notifications',
    key: 'broadcast',
    href: '/dashboards/broadcast',
    icon: <Notification style={iconStyle} />
  },
  // {
  //   title: 'Calendar',
  //   href: '/apps/calendar',
  //   icon: <DateRangeIcon style={iconStyle} />
  // },
  // {
  //   title: 'Notes',
  //   href: '/apps/notes',
  //   icon: <EventNoteIcon style={iconStyle} />
  // }, {
  //   title: 'Contacts',
  //   href: '/apps/contacts',
  //   icon: <FaceIcon style={iconStyle} />
  // }, {
  //   title: 'Chat',
  //   href: '/apps/chat',
  //   icon: <ChatIcon style={iconStyle} />
  // }
  // ]
  // },
  // {
  //   title: 'USER INTERFACE',
  //   type: 'header'
  // }, {
  //   title: 'Typography',
  //   href: '/pages/typography',
  //   icon: <TextFormatIcon style={iconStyle} />
  // }, {
  //   title: 'Colors',
  //   href: '/pages/colors',
  //   icon: <PaletteIcon style={iconStyle} />
  // },
  // {
  //   title: 'ELEMENTS',
  //   type: 'header'
  // },
  // {
  //   title: 'Form Controls',
  //   // icon: <ExtensionIcon style={iconStyle} />,
  //   children: [{
  //     title: 'Autocomplete',
  //     href: '/elements/autocomplete'
  //   }, {
  //     title: 'Selection Controls',
  //     href: '/elements/selection-controls'
  //   }, {
  //     title: 'Picker',
  //     href: '/elements/picker'
  //   }, {
  //     title: 'Text Fields',
  //     href: '/elements/text-fields'
  //   }, {
  //     title: 'Selects',
  //     href: '/elements/selects'
  //   }]
  // },
  // {
  //   title: 'Navigation',
  //   icon: <MenuIcon style={iconStyle} />,
  //   children: [{
  //     title: 'App Bar',
  //     href: '/elements/app-bar'
  //   }, {
  //     title: 'Menu',
  //     href: '/elements/menu'
  //   }]
  // },
  // {
  //   title: 'Layout',
  //   icon: <ViewModuleIcon style={iconStyle} />,
  //   children: [{
  //     title: 'List',
  //     href: '/elements/list'
  //   }, {
  //     title: 'Cards',
  //     href: '/elements/cards'
  //   }, {
  //     title: 'Paper',
  //     href: '/elements/paper'
  //   }, {
  //     title: 'Avatars',
  //     href: '/elements/avatars'
  //   }, {
  //     title: 'Steppers',
  //     href: '/elements/steppers'
  //   }]
  // },
  // {
  //   title: 'Buttons & Indicators',
  //   icon: <InfoIcon style={iconStyle} />,
  //   children: [{
  //     title: 'Buttons',
  //     href: '/elements/buttons'
  //   }, {
  //     title: 'Progress',
  //     href: '/elements/progress'
  //   }]
  // },
  // {
  //   title: 'PAGES',
  //   type: 'header'
  // },
  // {
  //   title: 'Authentication',
  //   icon: <PersonIcon style={iconStyle} />,
  //   children: [{
  //     title: 'Login',
  //     href: '/login'
  //   },
  //   {
  //     title: 'Register',
  //     href: '/register'
  //   },
  //   {
  //     title: 'Forgot Password',
  //     href: '/forgot-password'
  //   },
  //   {
  //     title: 'Profile',
  //     href: '/profile'
  //   },
  //   {
  //     title: 'Lock Screen',
  //     href: '/lock'
  //   }
  //   ]
  // },
  // {
  //   title: 'Errors',
  //   icon: <InfoIcon style={iconStyle} />,
  //   children: [{
  //     title: '404',
  //     href: '/errors/404'
  //   }, {
  //     title: '500',
  //     href: '/errors/500'
  //   }]
  // }
];

export default async function menuItemsFun() {
  groupId = await JSON.parse(cookie.load('groupId'));
  if (groupId === 1 || groupId === 5) {
    filterArray = filterMenuItem.filter(item => item.href !== '/dashboards/wallet'
      && item.href !== '/dashboards/returnorder' && item.href !== '/dashboards/order/new'
      && item.key !== 'newOrder' && item.href !== '/dashboards/cancelorder' && item.href !== '/dashboards/feedback'
      && item.href !== '/dashboards/notifications');
  } else if (groupId && groupId === 2) {
    filterArray = filterMenuItem.filter(item => item.href !== '/dashboards/chooseCatalog' && (item.href !== '/dashboards/offers')
      && item.href !== '/dashboards/wallet' && item.href !== '/dashboards/assets' && item.key !== 'newOrder'
      && item.href !== '/dashboards/returnedorders' && item.href !== '/dashboards/order/new' && item.href !== '/dashboards/cancelorder'
      && item.href !== '/dashboards/feedback' && item.key !== 'editorAssets'
      && item.href !== '/dashboards/settings' && item.href !== '/dashboards/notifications'
      && item.href !== '/dashboards/externalorder'
      && item.href !== '/dashboards/woocommerceorder/paid'
      && item.href !== '/dashboards/broadcast'
      && item.href !== '/dashboards/amount-report'
      // && item.href !== '/dashboards/wallet-report'
    );
  } else if (groupId && groupId === 3) {
    filterArray = filterMenuItem.filter(item =>
      item.href !== '/dashboards/chooseCatalog' && item.href !== '/report' && item.key !== 'editorAssets'
      && item.href !== '/dashboards/wallet' && item.href !== '/dashboards/assets'
      && item.href !== '/dashboards/returnorder' && item.href !== '/dashboards/returnedorders'
      && item.href !== '/dashboards/order/new' && item.key !== 'newOrder' && item.href !== '/dashboards/cancelorder'
      && item.href !== '/dashboards/feedback'
      && item.href !== '/dashboards/settings' && item.href !== '/dashboards/notifications'
      && item.href !== '/dashboards/externalorder'
      && item.href !== '/dashboards/woocommerceorder/paid'
      && item.href !== '/dashboards/broadcast'
      && item.href !== '/dashboards/amount-report'
      // && item.href !== '/dashboards/wallet-report'
    );
  } else if (groupId && groupId === 4) {
    filterArray = filterMenuItem.filter(item => item.href !== '/dashboards/catalog' && (item.key !== 'addOffer')
      && item.href !== '/dashboards/users' && item.href !== '/report'
      && item.href !== '/dashboards/assets' && item.key !== 'reports' && item.href !== '/dashboards/returnedorders'
      && item.href !== '/dashboards/order/paid' && item.href !== '/dashboards/chooseCatalog'
      && item.key !== 'editorAssets'
      && item.href !== '/dashboards/settings'
      && item.href !== '/dashboards/wallet-report'
      && item.href !== '/dashboards/externalorder'
      && item.href !== '/dashboards/woocommerceorder/paid'
      && item.href !== '/dashboards/broadcast'
      && item.href !== '/dashboards/amount-report'
    );
  } else {
    filterArray = filterMenuItem.slice(0);
  }

  return filterArray;
}



// WEBPACK FOOTER //
// ./src/config.js